export function readSvgMeta(svg, size) {
  if (svg) {
    const dataset = svg.dataset

    const width = dataset[`width-${size}`]

    return {
      width: width && Number(width),
    }
  }
}
